import {authenticationService} from './'
import { jwtDecode } from 'jwt-decode'

export function authHeader() {
    // return authorization header with jwt token
	if (window._accessToken) {
		return { 'Authorization': 'Bearer ' + window._accessToken };
	}
	return {};
}

export async function checkToken() {
	const tokens = authenticationService.currentUserValue;
	if (!tokens) return;

	const now = Date.now() / 1000;
	if (!window._accessToken || now > tokens.expiry) {
		const refreshTokenValue = tokens['refresh'] || tokens['refresh_token'];
		if (!refreshTokenValue) {
			console.error("No se encontró un token de refresco en tokens.");
			await authenticationService.logout();
		return;
		}
		const refresh = jwtDecode(refreshTokenValue);
		if (now > refresh['exp']) {
			console.log("Refresh token expirado, cerrando sesión");
			await authenticationService.logout();
		} else {
			await authenticationService.refreshToken();
		}
	}
}

export const renderNoHorsesFoundMessage = (message, onAddNewHorse) => {
	if (message === 'No horses found' && onAddNewHorse) {
		return (
			<div>
				No horses found.{' '}
				<br />
				<span 
					className="add-horse-link"
					onClick={(e) => {
						e.stopPropagation();
						onAddNewHorse();
					}}
				>
					Add new horse
				</span>
			</div>
		);
	}
	return message;
};

export const addHorseAlerts = {
	success: {
		type: 'success',
		title: 'Request submitted',
		description: 'Your horse request has been submitted. If pedigree data is found, the horse will appear in searches automatically.',
		okButtonText: 'Accept'
	},
	error: (message) => ({
		type: 'error',
		title: 'Error',
		description: message || 'An error occurred. Please try again.',
		okButtonText: 'Ok'
	})
};
